import { BranchFavoritesTypes, PartnerFavoritesTypes, ProfessionalFavoritesTypes } from '@/types';
import { restApiClient } from '@/datasources';

export async function getProfessional(withSpecialties: boolean = true): Promise<ProfessionalFavoritesTypes[]> {
  const { data: professionalsResponse } = await restApiClient.get<{ data: ProfessionalFavoritesTypes[] }>(
    'online/customers/favorites/professionals',
    {
      withSpecialties,
    },
  );

  return professionalsResponse.data;
}

export async function getLocals(): Promise<PartnerFavoritesTypes[]> {
  const { data: localsResponse } = await restApiClient.get<{ data: PartnerFavoritesTypes[] }>(
    'online/customers/favorites/locals',
  );

  return localsResponse.data;
}

export async function getBranches(): Promise<BranchFavoritesTypes[]> {
  const { data: localsResponse } = await restApiClient.get<{ data: BranchFavoritesTypes[] }>(
    'online/customers/favorites/branchs',
  );
  return localsResponse.data;
}

export async function addProfessionalFavorite(professionalId: string): Promise<void> {
  await restApiClient.post(`online/professionals/${professionalId}/favorite`, {});
}

export async function removeProfessionalFavorite(professionalId: string): Promise<void> {
  await restApiClient.post(`online/professionals/${professionalId}/unfavorite`, {});
}

export async function checkIfProfessionalIsFavorite(professionalId: string): Promise<boolean> {
  const favoritedProfessionals = await getProfessional(false);
  return favoritedProfessionals.some((item) => item.professional.id === professionalId);
}

export async function addPartnerFavorite(partnerId: string): Promise<void> {
  await restApiClient.post(`online/partner/clinic/${partnerId}/favorite`, {});
}

export async function removePartnerFavorite(partnerId: string): Promise<void> {
  await restApiClient.post(`online/partner/clinic/${partnerId}/unfavorite`, {});
}

export async function checkIfPartnerIsFavorite(partnerId: string): Promise<boolean> {
  const favoritedPartners = await getLocals();
  return favoritedPartners.some((item) => item?.partner?.id === partnerId);
}

export async function addBranchLaboratoryFavorite(branchLaboratoryId: string): Promise<void> {
  await restApiClient.post(`online/branch-laboratory/${branchLaboratoryId}/favorite`, {});
}

export async function removeBranchLaboratoryFavorite(branchLaboratoryId: string): Promise<void> {
  await restApiClient.post(`online/branch-laboratory/${branchLaboratoryId}/unfavorite`, {});
}

export async function checkIfBranchLaboratoryIsFavorite(branchLaboratoryId: string): Promise<boolean> {
  const favoritedPartners = await getLocals();

  return favoritedPartners.some((item) => item.branchLaboratory?.id === branchLaboratoryId);
}

export async function addBranchFavorite(branchLaboratoryId: string): Promise<void> {
  await restApiClient.post(`online/branches/${branchLaboratoryId}/favorite`, {});
}

export async function removeBranchFavorite(branchLaboratoryId: string): Promise<void> {
  await restApiClient.post(`online/branches/${branchLaboratoryId}/unfavorite`, {});
}

export async function checkIfBranchIsFavorite(branchId: string): Promise<boolean> {
  const favoritedPartners = await getBranches();

  return favoritedPartners.some((item) => item.branch.id === branchId);
}
